import $ from "jquery";
import { isInstalled, signData } from "./netidUtils";

// TODO: check the aspx specific stuff to see if it works
// TODO: use native stuff instead of jquery

function setupHccLogin() {
  if (!isInstalled()) {
    if (console) console.log("net id is not installed!");
    return;
  }

  if (console) console.log("setting up Hcc Login!");

  // Show "Login with HCC" button
  $("#cmdSign").removeClass("hide");

  // If this isn't a post back then try to auto login
  if (
    // TODO fix aspx stuff
    // "<%= Page.IsPostBack %>" == "False" &&
    // "<%= preventAutoLogin %>" == "False"
    true
  ) {
    var signatureResult = signChallenge();
    console.log("signatureResult", signatureResult);

    // Only "auto post back" if the signature seems to be valid
    if (signatureResult) {
      if (console) console.log("> postback with cmdSign");
      __doPostBack("cmdSign", "");
    }
  }
}

// Creates the login signature.
function signChallenge() {
  if (console) console.log("signing challenge");

  var challengeValue = $("#txtHCCChallenge").val();
  try {
    // Signs the timestamp.
    var hccIssuerString = $("#txtHCCIssuers").val();
    var signature = isInstalled()
      ? signData(challengeValue, hccIssuerString, true)
      : "";

    // Update the signature field with the returned data.
    $("#txtSignatureError").val("");
    $("#txtSignatureValue").val(signature);

    if (console) console.log("> signChallenge succeeded");
    return !!signature;
  } catch (err) {
    if (console) console.log("> signChallenge failed:");
    if (console) console.log(err);

    // Update the signature error field with the error number.
    $("#txtSignatureError").val(err.number);
    $("#txtSignatureValue").val("");

    return false;
  }
}

export default setupHccLogin;
